import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { commonAPI } from 'api/commonAPI';
import DeleteIcon from 'assets/images/icon/DeleteIcon';
import LargePlusIcon from 'assets/images/icon/LargePlusIcon';
import SearchIcon from 'assets/images/icon/SearchIcon';
import TagCloseIcon from 'assets/images/icon/TagCloseIcon';
import UploadIcon from 'assets/images/icon/UploadIcon';
import Zoom from 'assets/images/icon/Zoom';
import axios from 'axios';
import {
  classesKeywords,
  returnTopic,
} from 'constants/topic';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {
  cloneDeep,
  uniq,
} from 'lodash';
import { useQuery } from 'react-query';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { animated } from 'react-spring';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import {
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from 'recoil';
import {
    activeSubmit,
    fireSubmit,
    isAdmin,
    publishState, selectedMenu, subMenuState,
} from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
  DropdownMenu,
  Overlay,
} from 'view/components';
import CreatePopup from 'view/pages/Create/components/CreatePopup';

import { constCommon } from '../../../../../constants';
import hashIt from "hash-it";
import useSetHashData from "../../../../../hooks/useSetHashData";
import {fadeIn, fadeIn2, fadeInPopup} from "../../../../../styled/StyledComponent";
import PlusIcon from "../../../../../assets/images/icon/PlusIcon";
import Remove from "../../../../../assets/images/icon/Remove";

dayjs.extend(utc);

const date = [2023, 12 - 1, 11, 2, 0];
let ms = dayjs(Date.UTC.apply(null, date)).utc().format("YYYY-MM-DD hh:mm:ss");
// date 초기세팅
interface DetailsProps {
    subCategoryItem?: any;
    createId?: any;
}

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
    overlay?: boolean;
    isActive?:boolean
}

interface MenuProps {
    active?: boolean;
    display?: boolean;
}

interface ITimezone {
    label: string;
    value: string;
}

// 배열로 변환


function getCurrentTimeZone() {
    // 브라우저에서 현재 사용자의 타임존을 얻기
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
}

const publshObj = {
    tag: "NEW",
    keyword: [],
    publishDateTime: ms,
    publishNow: true,
    skillsTopics: [],
    // timeZone: {
    //     id: "string",
    //     rawOffset: 0,
    // },
    timeZone: getCurrentTimeZone(),
};
const Details: React.FC<DetailsProps> = () => {
    const {
        state: { createId },
    } = useLocation();
    const thumbnailInput = useRef(null);
    const navigate = useNavigate();
    const admin = useRecoilValue(isAdmin);
    const setSubmit = useSetRecoilState(activeSubmit);
    const [publishItem, setPublishItem] = useRecoilState(publishState);
    const [publishData, setPublishData] = useState(publshObj);
    const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);
    const [percentage, setPercentage] = useState(0);
    const [videoFileName, setVideoFileName] = useState("");
    const [thumbnailData, setTumbnailData] = useState(null);
    const [popupState, setPopupState] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [createTitle, setCreateTitle] = useState("");
    const [uploadData, setUploadData] = useState({
        title: "",
        category: "",
        subCategory: "",
        thumbnail: null,
        level: "",
        promotion: {
            id: null,
            title: "",
            fileName: "",
        },
        price:{
            "purePrice": 0,
            "discountedPrice": 0,
            "validFrom": null,
            "validTo": null
        }
    });

    const onClickPublishStat = (status: boolean) => {
        setPublishData({
            ...cloneDeep(publishData),
            publishNow: status,
        });
    };

    const getClassData = async () => {
        await classesAPI.getClassById(createId, null).then((res) => {
            console.log("classData", res, );
            const copyData = cloneDeep(res?.data?.details);
            setUploadData({
                category: copyData?.categoryInfo?.category || "",
                level: copyData?.level || "",
                price: copyData?.price,
                promotion: copyData?.promotion || { ...uploadData.promotion },
                subCategory: copyData?.categoryInfo?.subCategory || "",
                thumbnail: copyData?.thumbnail || "",
                title: copyData?.title || "",
            });
            setImageUrl(copyData?.thumbnail?.url);
        });
    };
    const [data, setData] = useState(null);
    const getCategory = async () => {
        const result = await commonAPI.getCategory(null).then((res) => {

            return res?.data;
        });

        if (!isEmpty(result)) {
            const data = result?.map((item: any) => item.category);
            const category = uniq([...data]);
            setData( { category: [...category], categoryData: result });
        }
        console.log("result", result);
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setImageUrl(e.target.result);
                setUploadData({
                    ...uploadData,
                    thumbnail: e.target.result,
                });
            };
            reader.readAsDataURL(file);
        }
        // FormData 생성
        const formData = new FormData();
        formData.append("thumbnail", selectedFile);

        setTumbnailData(file);
    };

    const getClassDetail = async () => {
        await classesAPI.getClassDetail(createId, null).then((res) => {
            console.log("classData", res);
        });
    }

    useEffect(() => {
        getCategory()
    }, []);
    const getSubCategory = (category: string): { subCategory: any; subCategoryDataArray: any } => {
        if (isEmpty(data)) return null;
        const subCategory = data?.categoryData
            ?.filter((item: any) => {
                return item?.category === category;
            })
            .map((item: any) => {
                return {
                    ...item,
                    dropdownItem: item?.subCategory,
                };
            });
            console.log('subCategoryDataArray', subCategory)
        return {
            // subCategory: subCategory[0]?.subCategory || "",
            subCategory:subCategory.find(findItem => findItem?.subCategory == uploadData?.subCategory)?.subCategory ?? "",
            subCategoryDataArray: subCategory,
        };
    };
    const getFormData = (uploadThumbnail) => {
        const thumbnailFile = thumbnailInput.current?.files?.[0];
        const formData = new FormData();
        const data = {
            // category: uploadData.category,
            categoryId:getSubCategory(uploadData?.category)?.subCategoryDataArray?.find(item => {
                return item.subCategory == uploadData?.subCategory
            })?.id,
            jwPlayerId: uploadData.promotion.id,
            level: uploadData?.level,
            price: uploadData?.price?.purePrice * 100,
            // subCategory: uploadData?.subCategory,
            title: uploadData?.title,
            promotionalVideoTitle:uploadData?.promotion?.title,
            promotionalFileName:uploadData?.promotion?.fileName,

        };

        // if(isEmpty(uploadData?.promotion?.title)) delete data.promotionalVideoTitle;
        // if(isEmpty(uploadData?.promotion?.fileName)) delete data.promotionalFileName;
        // if(isEmpty(uploadData.promotion.id)) delete  data?.jwPlayerId;
        formData.append('putDetails', JSON.stringify(cloneDeep(data)));
        console.log('uploadThumbnail', uploadThumbnail)
        if(uploadThumbnail){
            console.log("thumbnailFile", thumbnailFile);
            const thumbnailBlob = new Blob([thumbnailFile], {
                type: thumbnailFile?.type,
            });
            formData.append("thumbnail", thumbnailBlob, thumbnailFile?.name);
        }
        return formData;
    };
    const onClickTagDropDown = (item: any, key: string) => {
        setPublishData({
            ...publishData,
            [key]: item,
        });
    };
    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log('obj', obj)
        if(!isEmpty(obj)){
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        }else{
            selectItem = item
        }
        console.log('selectItem', selectItem)
        setUploadData({
            ...uploadData,
            [key]:selectItem,
        });
    };

    const onChangeDropdown = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
        setUploadData({
            ...uploadData,
            [key]: e.target.value,
        });
    };

    const onChangeTitle = (value: string) => {
        setCreateTitle(value);
    };
    const [selected, setSelected] = useRecoilState(selectedMenu);
    const [selectedSubMenu ,setSelectedSubMenu] = useRecoilState(subMenuState);

    const isAdminState = useRecoilValue(isAdmin);
    const createClass = async () => {
        await classesAPI.postClass({
            params:{
                title:createTitle,
            }
        }).then((res) => {
            if(!isAdminState){
                setSelected("Classes");
                navigate("/main/classes")
            }else{
                setSelected("Classes");
                navigate("/main/classes")
                setSelectedSubMenu("In Progress")
            }
            navigate("/create/details", {
                state: {
                    createId: res?.data?.id,
                },
            });
            setPopupState(false);
            titleInputRef?.current?.focus()
        });
    };

    const inputRef = useRef(null);
    const titleInputRef = useRef(null);

    useEffect(() => {
        titleInputRef?.current?.focus()
    }, [titleInputRef?.current]);
    const handleUploadJWP = async (event) => {
        const file = event.target.files[0];
        console.log("file", file);
        const videoElement = document.createElement('video');
        videoElement.preload = 'metadata';
        videoElement.src = URL.createObjectURL(file);

        await new Promise(resolve => {
            videoElement.onloadedmetadata = () => {
                //@ts-ignore
                resolve();
            };
        });

        if (uploadData.promotion.title.length === 0) {
            alert("Please enter a promotional video title");
            return;
        }
        if (!file) {
            return;
        }
        try {
            const duration = videoElement.duration;

            const result = await commonAPI.postVideoMetadata({
                data: {
                    metadata: {
                        title: uploadData.promotion.title,
                        duration:duration
                    },
                    upload: {
                        mimeType: file?.type,
                    },
                    fileName: file?.name,
                    preview: true,
                    drm:false
                },
            });
            if (result) {
                console.log("@video",result);
                const uploadLink = result.data.upload_link;
                if (result.data.jwPlayerId) {
                    setUploadData({
                        ...uploadData,
                        promotion: {
                            ...uploadData.promotion,
                            fileName: file?.name,
                            id: result.data.jwPlayerId,
                        },
                    });
                };
                const fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);
                fileReader.onload = async () => {
                    const arrayBuffer = fileReader.result as ArrayBuffer;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const buffer = uint8Array.slice();
                    axios({
                        method: "PUT",
                        url: uploadLink,
                        headers: {
                            "Content-Type": file?.type,
                        },
                        data: new Blob([buffer]),

                        onUploadProgress: (progressEvent) => {
                            const percentage =
                                (progressEvent.loaded / (progressEvent.total || 1)) * 100;
                            const percentCompleted = Math.round(percentage);
                            setPercentage(percentCompleted);
                        },
                    }).then((res) => {
                        console.log("video", res);
                        setVideoFileName(file?.name);
                    });
                };
            }
        } catch (error) {
            console.log("error", error);
        }
    };
    const getAdminData = async () => {
        await classesAPI.getAdminClassById(createId).then((res) => {
            // const mapDate = res?.publishDateTime?.map((item, index) => {
            //     if (index === 1) {
            //         return item - 1;
            //     }
            //     return item;
            // });
            // const dateItem = dayjs(Date.UTC.apply(null, mapDate)).utc().format();
            console.log("adminData@@1", res);
            if (!isEmpty(res?.data)) {
                setPublishData({
                    keyword: [...res?.data?.keyword],
                    publishDateTime: !isEmpty(res?.data?.publishDateTime) ?
                        dayjs(res?.data?.publishDateTime).format("YYYY-MM-DDTHH:mm:ss") :
                    dayjs(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
                    publishNow: isEmpty(res?.data?.publishNow) ? true : res?.data?.publishNow,
                    skillsTopics: res?.data?.skillsTopics,
                    timeZone: res?.data?.timeZone || getCurrentTimeZone(),
                    tag: res?.data?.tag || "NEW",
                });
            }
        });
    };

    const postAdminData = async () => {
        await classesAPI
            .postAdminClass(createId, {
                data: { ...cloneDeep(publishData) },
            })
            .then((res) => {
                console.log("adminData@@", res);
                if (!isEmpty(res?.data)) {
                    setPublishData({
                        ...res?.data,
                    });
                }
            });
    };

    const removeImage = () => {
        thumbnailInput.current.value = "";
        setImageUrl("");
    };

    const removeVideo = () => {
        inputRef.current.value = "";
        const copy = cloneDeep(uploadData);

        copy.promotion = { fileName: "", id: null, title: "" };
        setUploadData(copy);
    };
    useEffect(() => {
        if (admin) {
            getAdminData();
        }
    }, [admin]);
    console.log("admin", admin);
    const uploadDetail = async (next?:any) => {
        const thumbnailFile = thumbnailInput.current?.files?.[0];
     
        await classesAPI
            .putClassDetail(createId, {                
                // params: {
                //     category: uploadData.category,
                //     jwPlayerId: uploadData.promotion.id,
                //     level: uploadData?.level,
                //     <price>: uploadData?.price?.price,
                //     subCategory: uploadData?.subCategory,
                //     title: uploadData?.title,
                // },
                data:getFormData(thumbnailFile !== undefined),
            })            
            .then(async (res) => {
                console.log("@uploadData",uploadData);
                console.log("detail update", res);
                if(uploadData?.promotion?.id !== null){
                    commonAPI
                        .patchVideoMetadata(uploadData?.promotion?.id, {
                            data: {
                                title: uploadData?.promotion?.title,
                            },
                        })
                        .then(async (result) => {
                            console.log("fetch video", result);
                            // await getClassDetail();
                        });
                }

                if (admin) {
                    await postAdminData();
                }
                if(next){
                    navigate("/create/overview", {
                        state: {
                            createId: createId,
                        },
                    });
                }
            })

    };

    const getInProgress = () => {
        if (admin) {
            commonAPI?.getProgress(createId);
        }
    };

    const checkSubmitCondition = () => {
        const copyData = cloneDeep(uploadData);
        delete copyData.promotion;
        const checkValue = Object.entries(copyData)?.filter((item) => {
            return isEmpty(item[1]);
        });
        console.log("checkValue", checkValue);
        return isEmpty(checkValue);
    };

    const onSubmit = async () => {
        if (submitFire === true) {
            setSubmitFire(false);
            await uploadDetail();
        }
    };

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log(string, results);
    };

    const handleOnHover = (result) => {
        // the item hovered
        console.log(result);
    };

    const handleOnSelect = (item, key) => {
        // the item selected
        console.log(item);
        const copy = cloneDeep(publishData);
        copy[key].push(item);
        setPublishData(copy);
    };

    const handleOnFocus = () => {
        console.log("Focused");
    };

    const formatResult = (item) => {
        return (
            <DropdownItem>
                {/* <span style={{ display: "block", textAlign: "left" }}>id: {item.id}</span> */}
                <span>{item.name}</span>
            </DropdownItem>
        );
    };

    const onclickRemove = (index: number, key: string) => {
        const copy = cloneDeep(publishData);
        copy[key].splice(index, 1);
        setPublishData(cloneDeep(copy));
    };

    useEffect(() => {
        getClassData();
    }, [createId]);

    useEffect(() => {
        if (createId === null) {
            setPopupState((v) => !v);
        }
    }, [createId]);

    // useEffect(() => {
    //     setSubmit(checkSubmitCondition());
    // }, [uploadData]);

    // useEffect(() => {
    //     if (submitFire === true) {
    //         onSubmit();
    //     }
    // }, [submitFire]);

    useEffect(() => {
        setPublishItem(cloneDeep(publishData));
        // return () =>{
        //     itemRef.current();
        // }
    }, [publishData]);

    useEffect(() => {
        getInProgress();
    }, [admin]);

    useEffect(()=>{
        setUploadData({
            ...uploadData,
            subCategory:getSubCategory(uploadData?.category)?.subCategory || "",
        })
    },[uploadData?.category]);

    // const h = hashIt({
    //     uploadData
    // });
    // const itemRef = useRef(null);
    // useEffect(() => {
    //     itemRef.current = uploadDetail
    //     return () => {
    //         console.log("@h",h);
    //     }
    // }, [h]);

    // useSetHashData({data:uploadData, method:uploadDetail})
    const updateTime = (dateTime, newTime) => {
        if (!dateTime) dateTime = new Date();
        const [hours, minutes] = newTime.split(":");
        const updatedDateTime = new Date(dateTime);
        updatedDateTime.setHours(parseInt(hours, 10));
        updatedDateTime.setMinutes(parseInt(minutes, 10));
        return updatedDateTime;
    };
    
    console.log("uploadData", uploadData);
    console.log("publishData", publishData);
    console.log("@test",dayjs(publishData?.publishDateTime?.split(" ")[0]).format(
        "YYYY-MM-DD"
    ));

    return (
        <React.Fragment>

            {popupState === true && (
                <PopupWrap>
                    <CreatePopup
                        onChange={onChangeTitle}
                        value={createTitle}
                        onClick={() => {
                            createClass();
                        }}
                    />
                </PopupWrap>

            )}

            <Container>
                {!isEmpty(uploadData) && (
                    <Contents>
                        <Row>
                            <FormBox>
                                <dt>
                                    Title<strong>*</strong>
                                </dt>
                                <dd>
                                    <FormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <input
                                                    ref={titleInputRef}
                                                    onChange={(e) => {
                                                        onChangeDropdown(e, "title");
                                                    }}
                                                    type="text"
                                                    value={uploadData.title}
                                                    placeholder="Enter a title"
                                                    maxLength={70}
                                                />
                                                <TextLength>
                                                    {70 - uploadData.title.length}
                                                </TextLength>
                                            </FormItem>
                                        </li>
                                    </FormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Row>
                        <Row display={"flex"}>
                            <Col>
                                <FormBox>
                                    <dt>
                                        Price<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <DropdownMenu
                                                        altText={"Select price"}
                                                        selected={
                                                            uploadData?.price?.purePrice === null ||
                                                            uploadData?.price?.purePrice === undefined
                                                                ? ""
                                                                : (uploadData?.price?.purePrice == 0 ? "Free" : `$${uploadData?.price?.purePrice}`)
                                                        }
                                                        items={constCommon.CLASSES_PRICE.map(priceItem => {
                                                            return{
                                                                ...priceItem,
                                                                dropdownItem:priceItem.purePrice == 0 ? "Free" :`$${priceItem.purePrice}`
                                                            }
                                                        }) || []}
                                                        state={"price"}
                                                        onClick={onClickDropdown}
                                                    />
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                            <Col
                                className={"selectLevel"}
                            >
                                <FormBox>
                                    <dt>
                                        Level<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <DropdownMenu
                                                        altText={"Select level"}
                                                        selected={uploadData?.level}
                                                        items={constCommon.CLASSES_LEVEL}
                                                        state={"level"}
                                                        onClick={onClickDropdown}
                                                    />
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                        </Row>
                        <Row display={"flex"}>
                            <Col>
                                <FormBox>
                                    <dt>
                                        Category - 1<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <DropdownMenu
                                                        altText={"Select 1st category"}
                                                        selected={uploadData?.category}
                                                        items={data?.category || []}
                                                        state={"category"}
                                                        onClick={onClickDropdown}
                                                    />
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                            <Col
                                className={"category2"}
                            >
                                <FormBox style={{ opacity: uploadData?.category == "" ? 0.4 : 1 }}>
                                    <dt>
                                        Category - 2<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem
                                                    style={{
                                                        pointerEvents:
                                                            uploadData?.category == ""
                                                                ? "none"
                                                                : "all",
                                                    }}
                                                >
                                                    <DropdownMenu
                                                        selected={uploadData?.subCategory}
                                                        state={"subCategory"}
                                                        altText={"Select 2nd category"}
                                                        onClick={onClickDropdown}
                                                        items={
                                                            getSubCategory(uploadData?.category)
                                                                ?.subCategoryDataArray?.map(arrItem => {
                                                                    return arrItem?.subCategory
                                                                }) || []
                                                        }
                                                        // obj
                                                        // items={
                                                        //     getSubCategory(uploadData?.category)
                                                        //         ?.subCategoryDataArray || []
                                                        // }
                                                    />
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                        </Row>
                        <Row display={"flex"}>
                            <Col>
                                <ThumbnailWrap>
                                    <ThumbnailTitle>
                                        Thumbnail<strong>*</strong>
                                    </ThumbnailTitle>
                                    <ThumbnailText>
                                        Select or upload a picture that shows what’s in your video.
                                        A good thumbnail stands out and draws viewer’s attention.
                                    </ThumbnailText>
                                    <ThumbnailUpload>
                                        <ThumbnailView className={"img"} overlay={isEmpty(imageUrl)}>
                                            {!isEmpty(imageUrl) && (
                                                <ThumbnailButtonList>
                                                    <li>
                                                        <button onClick={removeImage}>
                                                            <DeleteIcon />
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            onClick={()=>{
                                                                thumbnailInput.current.click()
                                                            }}
                                                        >
                                                            <UploadIcon />
                                                        </button>
                                                    </li>
                                                </ThumbnailButtonList>
                                            )}
                                            {isEmpty(imageUrl) ? (
                                                <UploadText className={"plus"}>
                                                    <LargePlusIcon />
                                                    <p>Upload Image</p>
                                                </UploadText>
                                            ) : (
                                                <img src={imageUrl} alt="" />
                                            )}

                                            <input
                                                className={"imgInput"}
                                                type={"file"}
                                                accept="image/*"
                                                // onChange={handleFileChange}
                                                onChange={(e) => {
                                                    handleFileChange(e);
                                                }}
                                                ref={thumbnailInput}
                                            />
                                        </ThumbnailView>
                                    </ThumbnailUpload>
                                </ThumbnailWrap>
                            </Col>
                            <Col style={{ alignItems: "flex-end", display: "flex" }}
                                className={"promotionalVideo"}
                            >
                                <ThumbnailWrap>
                                    {/*<ThumbnailTitle>Promotional video</ThumbnailTitle>*/}
                                    {/*<ThumbnailText>*/}
                                    {/*    Upload your promo video. Well-made ones can boost student*/}
                                    {/*    enrollment by 5 to 10 times.*/}
                                    {/*</ThumbnailText>*/}
                                    {/*<ThumbnailUpload className={"video"}>*/}
                                    {/*    <ThumbnailView overlay={isEmpty(uploadData?.promotion?.id)}>*/}
                                    {/*        {!isEmpty(uploadData?.promotion?.id) && (*/}
                                    {/*            <ThumbnailButtonList>*/}
                                    {/*                /!*<li>*!/*/}
                                    {/*                /!*    <button>*!/*/}
                                    {/*                /!*        <Zoom />*!/*/}
                                    {/*                /!*    </button>*!/*/}
                                    {/*                /!*</li>*!/*/}
                                    {/*                <li>*/}
                                    {/*                    <button*/}
                                    {/*                        onClick={() => {*/}
                                    {/*                            removeVideo();*/}
                                    {/*                        }}*/}
                                    {/*                    >*/}
                                    {/*                        <DeleteIcon />*/}
                                    {/*                    </button>*/}
                                    {/*                </li>*/}
                                    {/*                <li>*/}
                                    {/*                    <button*/}
                                    {/*                        onClick={() => {*/}
                                    {/*                            inputRef.current.click()*/}
                                    {/*                        }}*/}
                                    {/*                    >*/}
                                    {/*                        <UploadIcon/>*/}
                                    {/*                    </button>*/}
                                    {/*                </li>*/}
                                    {/*            </ThumbnailButtonList>*/}
                                    {/*        )}*/}
                                    {/*        {uploadData?.promotion?.id === null ? (*/}
                                    {/*            <UploadText className={"plus"}>*/}
                                    {/*                <LargePlusIcon/>*/}
                                    {/*                <p>Upload Video</p>*/}
                                    {/*            </UploadText>*/}
                                    {/*        ) : (*/}
                                    {/*            <p>*/}
                                    {/*                {uploadData?.promotion?.fileName ||*/}
                                    {/*                    videoFileName}*/}
                                    {/*            </p>*/}
                                    {/*        )}*/}

                                    {/*        <input*/}
                                    {/*            ref={inputRef}*/}
                                    {/*            type={"file"}*/}
                                    {/*            accept="video/*"*/}
                                    {/*            onChange={(e) => {*/}
                                    {/*                handleUploadJWP(e);*/}
                                    {/*                inputRef.current.value = "";*/}
                                    {/*            }}*/}
                                    {/*        />*/}
                                    {/*    </ThumbnailView>*/}
                                    {/*</ThumbnailUpload>*/}
                                </ThumbnailWrap>
                            </Col>
                        </Row>
                        <Row>
                            <FormBox>
                                <dt style={{marginBottom:8}}>Promotional video</dt>
                                {/*<dd>*/}
                                {/*    <FormBoxItemWrap>*/}
                                {/*        <li>*/}
                                {/*            <FormItem>*/}
                                {/*                <input*/}
                                {/*                    value={uploadData?.promotion?.title}*/}
                                {/*                    onChange={(*/}
                                {/*                        e: React.ChangeEvent<HTMLInputElement>*/}
                                {/*                    ) => {*/}
                                {/*                        setUploadData({*/}
                                {/*                            ...uploadData,*/}
                                {/*                            promotion: {*/}
                                {/*                                ...uploadData.promotion,*/}
                                {/*                                title: e.target.value,*/}
                                {/*                            },*/}
                                {/*                        });*/}
                                {/*                    }}*/}
                                {/*                    type="text"*/}
                                {/*                    placeholder="Enter a title"*/}
                                {/*                    maxLength={80}*/}
                                {/*                />*/}
                                {/*                <TextLength>*/}
                                {/*                    {80 - uploadData?.promotion?.title?.length}*/}
                                {/*                </TextLength>*/}
                                {/*            </FormItem>*/}
                                {/*        </li>*/}
                                {/*    </FormBoxItemWrap>*/}
                                {/*</dd>*/}

                                <VideoItems
                                    className={"practice"}
                                    style={{ width: "100%" }}>
                                    <FormItem
                                        style={{
                                            marginRight: 18,
                                            width:"calc((100% - 18px) / 2)",
                                            minWidth:"calc((100% - 18px) / 2)",
                                        }}
                                        className={"videoTitle"}
                                    >
                                        <input
                                            value={uploadData?.promotion?.title}
                                            onChange={(
                                                e: React.ChangeEvent<HTMLInputElement>
                                            ) => {
                                                setUploadData({
                                                    ...uploadData,
                                                    promotion: {
                                                        ...uploadData.promotion,
                                                        title: e.target.value,
                                                    },
                                                });
                                            }}
                                            type="text"
                                            placeholder="Enter a title"
                                            maxLength={80}
                                        />
                                        <TextLength>{80 - uploadData?.promotion?.title?.length}</TextLength>
                                    </FormItem>
                                    <FormItem
                                        className={"choose"}
                                        style={{
                                            marginRight: 18,
                                            width:"calc(50% - 120px)"
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Choose files"
                                            readOnly={true}
                                            value={uploadData?.promotion?.fileName || ""}
                                        />
                                    </FormItem>
                                    <Browse
                                        className={"chooseBtn"}
                                    >
                                        <PlusIcon/>
                                        <span>Browse</span>
                                        <input
                                            ref={inputRef}
                                            type={"file"}
                                            accept="video/*"
                                            onChange={(e) => {
                                                handleUploadJWP(e);
                                                inputRef.current.value = "";
                                            }}
                                        />
                                    </Browse>
                                </VideoItems>
                            </FormBox>
                        </Row>
                    </Contents>
                )}
                {admin && (
                    <AdminContents>
                        <Col style={{ width: "30%" }}>
                            <FormBox>
                                <dt>
                                    Class Tag<strong>*</strong>
                                </dt>
                                <dd>
                                    <FormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <DropdownMenu
                                                    altText={"Class tag"}
                                                    selected={publishData?.tag}
                                                    items={["NEW", "POPULAR", "UPDATED", "NO_TAG"]}
                                                    state={"tag"}
                                                    onClick={onClickTagDropDown}
                                                />
                                            </FormItem>
                                        </li>
                                    </FormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                        <div style={{ height: 20 }}></div>
                        <Row>
                            <Col style={{ width: "100%" }}>
                                <FormBox>
                                    <dt>
                                        Skills/Topics<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap style={{ width: "70%" }}>
                                            <li>
                                                <FormItem>
                                                    <ReactSearchAutocomplete
                                                        items={returnTopic(
                                                            uploadData?.category
                                                        )?.filter((item) => {
                                                            return !publishData?.skillsTopics?.find(
                                                                (findItem) => {
                                                                    return findItem == item?.name;
                                                                }
                                                            );
                                                        })}
                                                        onSearch={handleOnSearch}
                                                        onHover={handleOnHover}
                                                        onSelect={(item) => {
                                                            console.log("item", item);
                                                            handleOnSelect(
                                                                item?.name,
                                                                "skillsTopics"
                                                            );
                                                        }}
                                                        className={"topics"}
                                                        onFocus={handleOnFocus}
                                                        styling={{
                                                            borderRadius: "8px",
                                                            hoverBackgroundColor: "#33333360",
                                                        }}
                                                        autoFocus
                                                        showIcon={false}
                                                        formatResult={formatResult}
                                                    />
                                                    <SearchIconBox>
                                                        <SearchIcon />
                                                        <span>Search</span>
                                                    </SearchIconBox>
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                                <Tags>
                                    {publishData?.skillsTopics?.filter(item => {
                                        return  item !== ""
                                    })?.map((item, index) => (
                                        <TagItem>
                                            <span>{item}</span>
                                            <div
                                                onClick={() => {
                                                    onclickRemove(index, "skillsTopics");
                                                }}
                                            >
                                                <TagCloseIcon />
                                            </div>
                                        </TagItem>
                                    ))}
                                </Tags>
                            </Col>
                        </Row>
                        <div style={{ height: 0 }}></div>
                        <Row>
                            <Col style={{ width: "100%" }}>
                                <FormBox>
                                    <dt>
                                        Keywords<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap style={{ width: "70%" }}>
                                            <li>
                                                <FormItem className="search">
                                                    <ReactSearchAutocomplete
                                                        items={classesKeywords?.filter((item) => {
                                                            return !publishData?.keyword?.find(
                                                                (findItem) => {
                                                                    return findItem == item.name;
                                                                }
                                                            );
                                                        })}
                                                        onSearch={handleOnSearch}
                                                        onHover={handleOnHover}
                                                        onSelect={(item) => {
                                                            console.log("item", item);
                                                            handleOnSelect(item?.name, "keyword");
                                                        }}
                                                        className={"keywords"}
                                                        onFocus={handleOnFocus}
                                                        styling={{
                                                            borderRadius: "8px",
                                                            hoverBackgroundColor: "#33333360",
                                                        }}
                                                        autoFocus
                                                        showIcon={false}
                                                        formatResult={formatResult}
                                                    />
                                                    <SearchIconBox>
                                                        <SearchIcon />
                                                        <span>Search</span>
                                                    </SearchIconBox>
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                                <Tags>
                                    {publishData?.keyword?.filter(item => {
                                        return item !== ""
                                    })?.map((item, index) => (
                                        <TagItem>
                                            <span>{item}</span>
                                            <div
                                                onClick={() => {
                                                    onclickRemove(index, "keyword");
                                                }}
                                            >
                                                <TagCloseIcon />
                                            </div>
                                        </TagItem>
                                    ))}
                                </Tags>
                            </Col>
                        </Row>
                        <Divider />
                        <Publish>
                            <h4>Publish</h4>

                            <MenuItem
                                onClick={() => {
                                    onClickPublishStat(false);
                                }}
                                display={true}
                                className={publishData.publishNow === false ? "on" : ""}
                            >
                                <Circle />
                                <span>Schedule</span>
                            </MenuItem>

                            <DateItems>
                                <DateItem>
                                    <span>Date</span>
                                    <input
                                        type={"date"}
                                        name="date"
                                        value={dayjs(publishData?.publishDateTime?.split(" ")[0]).format(
                                            "YYYY-MM-DD"
                                        )}
                                        onChange={(e) => {
                                            console.log("dateTest", e.target.value);
                                            const date = new Date(e.target.value);
                                            const day = dayjs(date).format("YYYY-MM-DD");
                                            // const data =`${day} ${publishData?.publishDateTime?.split(" ")[1]}`
                                            const time = publishData?.publishDateTime?.split("T")[1];
                                            const isoDateTime = time == undefined ? `${day}` : `${day} ${time}`;
                                            console.log("day", time);
                                            setPublishData({
                                                ...cloneDeep(publishData),
                                                publishDateTime: dayjs(isoDateTime).format("YYYY-MM-DDTHH:mm:ss"),
                                            });
                                        }}

                                    />
                                </DateItem>
                                <DateItem>
                                    <span>Time</span>
                                    <input
                                        type="time"
                                        name="time"
                                        value={dayjs(publishData?.publishDateTime).format("HH:mm:ss")}
                                        onChange={(e) => {
                                            console.log("eeee@", e.target.value);

                                            const value = e.target.value;
                                            const day = publishData?.publishDateTime?.split("T")[0]
                                            const data = `${publishData?.publishDateTime?.split("T")[0]} ${value}`;
                                            console.log("@day",day);
                                            // const dateData = dayjs(data).format("YYYY-MM-DD HH:mm:ss")
                                            // const data = `${publishData?.publishDateTime?.split(" ")[0]} ${value}`;
                                            const dateData = dayjs(data).format("YYYY-MM-DDTHH:mm:ss"); // ISO 8601 형식으로 변경
                                            console.log("dateData",dateData);
                                            setPublishData({
                                                ...cloneDeep(publishData),
                                                publishDateTime: dateData,
                                            });
                                        }}
                                    />
                                </DateItem>
                                <DateItem>
                                    <span>Timezone</span>
                                    <TimezoneSelect
                                        className="timeZone"
                                        displayValue={"UTC"}
                                        labelStyle={"abbrev"}
                                        timezones={{
                                            ...allTimezones,
                                            "America/Lima": "Pittsburgh",
                                            "Europe/Berlin": "Frankfurt",
                                        }}
                                        value={publishData?.timeZone || getCurrentTimeZone()}
                                        onChange={(e: ITimezone) => {
                                            console.log("e", e);
                                            setPublishData({
                                                ...cloneDeep(publishData),
                                                timeZone: e.value,
                                            });
                                        }}
                                    />
                                </DateItem>
                            </DateItems>
                            <MenuItem
                                onClick={() => {
                                    onClickPublishStat(true);
                                }}
                                display={true}
                                className={publishData.publishNow === true ? "on" : ""}
                            >
                                <Circle />
                                <span>Publish now</span>
                            </MenuItem>
                        </Publish>
                    </AdminContents>
                )}
                <ButtonItems
                    className={"continue"}
                    isActive={isEmpty(uploadData.title) || isEmpty(uploadData?.price) || isEmpty(uploadData?.level)
                    || isEmpty(uploadData.subCategory) || isEmpty(uploadData.category)}
                    justifyContent={"flex-end"}>
                    <button onClick={()=>{uploadDetail(true)}}>Continue</button>
                </ButtonItems>
            </Container>
        </React.Fragment>
    );
};
export default Details;

const Container = styled.div`
    //overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;
const PopupWrap = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 50%;
    top: 50%;
    display:flex;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, -50%);
    z-index: 99999999;
    //background: #33333360;
    //animation: ${fadeIn2} 0.55s linear;
    & > div{
        position: fixed;
        
        animation: ${fadeInPopup} 0.5s linear;    
    }
`
const Contents = styled.div`
    padding: 20px;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
    @media screen and (max-width: 768px) {
        flex-direction: column; 
        width: 100%;
        & > div{
            width: 100%;
        }
    }
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
    @media screen and (max-width: 768px) {
        &.selectLevel{
            margin-top: 15px;    
        }
        &.category2{
            margin-top: 15px;
        }
        &.promotionalVideo{
            margin-top: 15px;
        }
    }
`;

const FormBox = styled.dl`
    > dt {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;
const SearchIconBox = styled.div`
    padding-right: 21px;
    padding-left: 10px;
    position: absolute;
    background: #e5e5e5;
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    height: 100%;
    width: 105px;
    right: 0;
    top: 0;
    border-radius: 0 8px 8px 0;
    span {
        font-size: 16px;
        font-weight: 700;
    }
`;
const FormItem = styled.div`
    position: relative;
    .topics {
        z-index: 9999;
    }
    .keywords {
        z-index: 999;
    }

    input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
    width: 100%;
`;

const ThumbnailTitle = styled.h5`
    font-family:"Europa-Regular";
    //font-size: 20px;
    //font-weight: 700;
    //line-height: 20px;
    font-size: 16px;
    font-weight: 400!important;
    letter-spacing: 0em;
    line-height: 24px;
    text-align: left;
    margin-bottom: 0.6rem;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 50%;
    &.video{
        width: 100%;
    }
    
    height: 180px;
    min-width: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div<StyledComponentProps>`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    input {
        position: absolute;
        z-index: 999;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    
    }
    
    &:hover {
        &::before {
            opacity: 0.3;
        }
        
        .plus{
            padding: 10px;
            svg{
                background: #e5e5e5;
            }
        }
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 9999;
    left: 0;
    top: 0;
    opacity: 0;
    transition: 0.2s;
    background: #33333340;
    &:hover {
        opacity: 1;
    }
    > li {
        margin: 0 4px;
        &:hover{
            transform: scale(1.1);
        }
    }
`;

const UploadText = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    svg{
        transition: all 0.2s;
        padding: 8px;
        border-radius: 50%;
        box-sizing: content-box;
    }
    p {
        margin-top: 10px;
        font-size: 18px;
    }
  
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: ${(props) => props.justifyContent};
    border-top: solid 1px rgba(51, 51, 51, 0.3);
    &.continue{
        button{
            font-family: Europa-Regular;
            font-size: 18px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;    
        }
    }
    button {
        transition: all 0.2s;
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        //background: #ddc160;
        border: solid 1px ${(props) => props.isActive ? "#ddd" : "#333"};
        background: ${(props) => props.isActive ? "#ddd" : "#333"};
        pointer-events: ${(props) => props.isActive ? "none" : "all"};
        &:hover{
            background: ${(props) => !props.isActive ? "#fff" : "#333"};
            color: #333;
        }
    }
`;

const AdminContents = styled.div`
    padding: 30px 20px 20px 20px;
    border-top: solid 1px rgba(51, 51, 51, 0.3);
`;

const Publish = styled.div`
    padding-top: 15px;
    h4 {
        opacity: 0.8;
        font-size: 26px;
        font-weight: 700;
    }
`;

const Check = styled.div``;

const Circle = styled.div`
    transition: all 0.2s;
    .on & {
        border: solid 4px #ddc160;
    }
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 8px;
    border: solid 1px #333;
`;

const MenuItem = styled.div<MenuProps>`
    transition: all 0.5s;
    transform: translateX(${(props) => (!props.display ? "-40px" : "none")});
    &.on {
        opacity: 1;
    }
    opacity: 0.6;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 20px 0;
    &:last-child {
        padding-bottom: 0px !important;
    }

    span {
        font-size: 16px;
        font-weight: 600;
        display: flex;
        height: 16px;
        align-items: center;
        padding-top: 3px;
        margin-left: 4px;
    }
`;

const DateItems = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

const DateItem = styled.div`
    display: flex;
    flex-direction: column;
    width: calc((100% - 36px) / 3);
    .timeZone {
        margin-top: 10px;
        height: 48px;
        & > div {
            border: solid 1px rgba(51, 51, 51, 0.3);
            border-radius: 8px;
            & > div {
                cursor: pointer;
                &:nth-child(1) {
                    & > div {
                        height: 38px;
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
    }
    input {
        padding: 0 15px;
        display: flex;
        margin-top: 10px;
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);

        display: flex;
        align-items: center;
        height: 48px;
    }
`;

const Tags = styled.div`
    display: flex;
    margin-top: 20px;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
`;
const TagItem = styled.div`
    display: flex;
    margin-bottom: 10px;
    cursor: pointer;
    align-items: center;
    box-shadow: 0px 0px 6px rgba(51, 51, 51, 0.16);
    border-radius: 4px;
    padding: 11px 10px;
    margin-left: 10px;
    div {
        height: 100%;
        display: flex;
        align-items: center;
    }
    &:first-child {
        margin-left: 0px;
    }
    span {
        display: flex;
        color: #333;
        font-weight: 600px;
        margin-right: 6px;
        font-size: 14px;
    }
`;
const Divider = styled.div`
    height: 1px;
    background: rgba(51, 51, 51, 0.3);
    margin-bottom: 20px;
    margin-top: 20px;
    width: calc(100% + 40px);
    transform: translateX(-20px);
`;

const DropdownItem = styled(animated.div)`
    transform: translateX(-10px);
    padding: 0 10px;
    background: #fff;
    width: 100%;
    font-family: Europa-Regular;
    font-size: 16px;
    border-bottom: solid 1px rgba(51, 51, 51, 0.3);
    height: 48px;
    cursor: pointer;
    display: flex;
    align-items: center;
    background: #fff;
    span {
        user-select: none;
    }
`;
const VideoItems = styled.div`
      display: flex;
      transition: all 0.2s;
      align-items: center;
      margin-bottom: 16px;
      position: relative;
      @media screen and (max-width: 768px) {
          flex-direction: column;
          width: 100%;
          align-items: flex-start;
          &.practice{
              width: 100%!important;
              .choose{
                  width: calc(100% )!important;
                  max-width: calc(100% )!important;
                  min-width: calc(100% )!important;
              }
              .chooseBtn{
                  //width: calc(100% - 30px)!important;
                  max-width: calc(100% )!important;
                  min-width: calc(100% )!important;
              }
              .removeButton{
                  position: absolute;
                  top: 134px;
                  transform: translateY(-50%);
                  &.transcript{
                      top: 50%;
                      width: 24px!important;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 10px 0;
                  }
                  svg{
                      width: 20px!important;
                      height: 20px;
                  }
                  left: calc(100% - 20px);
                  z-index: 999;
              }
          }
          & > div{
              width: 100%!important;
              margin-right: 0!important;
              margin-bottom: 8px;
          }
      }
  `;
const Browse = styled.div`
      position: relative;
      transition: all 0.2s;
      cursor: pointer;
      height: 48px;
      border-radius: 8px;
      padding: 0 18.5px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px #333;
      flex: 1;
      width: 100%;
      max-width: 120px;
      &.prev{
          width: 100px;
          max-width: 100px;
          padding: 0!important;
      }
      &.add{
          width: 100px;
          max-width: 100px;
          padding: 0!important;
      }
      &:hover{
          background: #333;
          border-color: #333;
          span{
              color: #fff!important;    
          }
          
          svg{
              path{
                  fill: #fff!important;
              }
          }
          span{
              color: #fff;

          }
      }
      @media screen and (max-width: 768px) {
          width: 100%!important;
          min-width: 100%;
          max-width: 100%;
          min-height: 46px;
          &.prev{
              min-width: 95px;
              max-width: 95px;
              min-height: 40px;
          }
          &.add{
              min-width: 95px;
              max-width: 95px;
              min-height: 40px;
              height: 40px;
          }
      }
      span {
          margin-left: 10px;
          font-size: 18px;
          color: #333;
      }
      img {
          width: 100%;
          height: 100%;
          object-fit: contain;
      }
      svg{
          width: 16px;
          height: 16px;
          path{
              fill: #333!important;
          }
      }
      input {
          position: absolute;
          width: 100%;
          height: 100%;
          background: #333;
          opacity: 0;
          z-index: 3;
      }
  `;
